<template>
    <modal
        title="KFZ hinzufügen"
        ref="modal"
        :showDismissMessage="showDismissMessage"
    >
        <form @submit.prevent="submitForm">
            <base-select
                v-model="beteiligteFormData.kfzart"
                id="kfzart"
                label="Fahrzeugtyp *"
            >
                <ion-select-option value="PKW">PKW</ion-select-option>
                <ion-select-option value="LKW">LKW</ion-select-option>
                <ion-select-option value="Motorrad">Motorrad</ion-select-option>
            </base-select>
            <ion-grid>
                <ion-row>
                    <ion-col size="12" size-md="6">
                        <base-input
                            id="kfzmarke"
                            v-model="beteiligteFormData.kfzmarke"
                            type="text"
                            label="Marke *"
                        ></base-input>
                    </ion-col>
                    <ion-col size="12" size-md="6">
                        <base-input
                            id="kennzeichennummer"
                            v-model="beteiligteFormData.kennzeichennummer"
                            type="text"
                            label="Kennzeichen *"
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="12">
                        <base-input
                            id="kmstand"
                            v-model="beteiligteFormData.kmstand"
                            type="number"
                            inputmode="decimal"
                            label="Km-Stand"
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="12">
                        <base-input
                            id="kfz-versicherung"
                            v-model="beteiligteFormData.kfzVersicherung"
                            type="text"
                            label="KFZ Versicherung bei"
                        ></base-input>
                    </ion-col>
                    <ion-col size="12">
                        <base-input
                            id="polizze"
                            v-model="beteiligteFormData.polizze"
                            type="text"
                            label="Polizzennummer"
                        ></base-input>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </form>
        <template v-slot:footer>
            <ion-button
                :disabled="
                    beteiligteFormData.kfzart === '' ||
                    beteiligteFormData.kfzmarke === '' ||
                    beteiligteFormData.kennzeichennummer === ''
                "
                expand="block"
                class="-round"
                @click="submitForm()"
                >Speichern</ion-button
            >
        </template>
    </modal>
</template>

<script>
import Modal from "@/components/Modal";
import BaseInput from "@/components/BaseInput";
import BaseSelect from "@/components/BaseSelect";

export default {
    props: {},
    components: {
        Modal,
        BaseInput,
        BaseSelect,
    },
    data() {
        return {
            beteiligteFormData: {
                kfzart: "",
                kfzmarke: "",
                kennzeichennummer: "",
                kmstand: "",
                kfzVersicherung: "",
                polizze: "",
            },
            isMe: false,
            changeBeteiligteFormDataCount: 0,
            showDismissMessage: false,
        };
    },
    watch: {
        beteiligteFormData: {
            deep: true,
            handler() {
                if (this.changeBeteiligteFormDataCount > 0) {
                    this.showDismissMessage = true;
                }
                this.changeBeteiligteFormDataCount++;
            },
        },
    },
    mounted() {},
    methods: {
        submitForm() {
            this.$ionic.modalController.dismiss({
                beteiligteFormData: this.beteiligteFormData,
            });
        },
    },
};
</script>

<style lang="scss" scoped></style>
